import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../../../Core/Image';
import chevronRightBlack from '../../../../images/black-chevron-large-right.svg';
import chevronRightDisabled from '../../../../images/disabled-chevron-large-right.svg';
import chevronLeftBlack from '../../../../images/black-chevron-large-left.svg';
import chevronLeftDisabled from '../../../../images/disabled-chevron-large-left.svg';

export const Tab = styled.div`
  position: relative;

  &:first-child {
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      vertical-align: middle;
    }

    & > div.chart {
      margin: 0 auto;
      padding: 0.5rem 0;
      align-items: center;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        margin: 0 1rem 0 0;
        padding: 1.5rem 0;
        justify-content: flex-start;
      }
    }
  }

  &.chart & {
    text-align: center;
    height: auto;
    width: ${props => `calc(100% / (${props.columnCount} - 1))`};
    padding: 0;
    display: inline-block;
    min-height: 6.625rem;

    @media only screen and (min-width: 360px) {
      min-height: 7rem;
    }

    @media only screen and (min-device-width: 435px) and (orientation: landscape) {
      min-height: 8.375rem;
    }

    @media only screen and (min-width: 575px) {
      min-height: 7rem;
    }

    &.selectable-card {
      &.is-selectable {
        &:before {
          display: none;
        }
      }

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        vertical-align: middle;
        width: ${props => `calc(100% / ${props.columnCount})`};

        &:first-child {
          text-align: left;
          width: ${props => `calc(100% / ${props.columnCount})`};
        }
      }

      &:before {
        display: none;
      }

      &.optimum {
        background-color: ${themeGet('colors.chart-pink')};
      }

      &.pc-mastercard {
        background-color: ${themeGet('colors.light-border-grey')};
      }

      &.pc-money {
        background-color: ${themeGet('colors.velvet')};

        p,
        span {
          color: ${themeGet('colors.white')};
        }
      }

      &.white {
        background-color: ${themeGet('colors.white')};
      }

      &.selectable-card {
        &.is-selectable {
          &:before {
            display: none;

            @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
              content: '';
              width: 100%;
              height: 20px;
              background-color: ${themeGet('colors.pc-red')};
              display: block;
              border: none;
              position: absolute;
            }
          }

          &.is-not-active {
            &:before {
              display: none;
            }
          }
        }

        &.is-not-active {
          background-color: transparent;
        }

        &.mobile {
          &:first-child {
            width: 100%;

            background: linear-gradient(
              to right,
              ${themeGet('colors.chart-pink')} 50%,
              ${themeGet('colors.light-border-grey')} 50% 100%
            );
            border-radius: 6px 6px 0 0;

            @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
              background: none;
              border-radius: 0;
            }
          }
          width: 50%;
        }
        &.carousel-tab {
          width: 100%;
        }
      }
    }

    &:first-child {
      width: 100%;

      &.mobile .sticky {
        display: none;
      }
    }
  }
`;

export const ContentWrapper = styled.div`
  &.chart {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    min-height: 7.125rem;
    padding: 0.5rem 0;

    @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
      min-height: 7.875rem;
    }

    @media only screen and (min-width: 575px) {
      min-height: auto;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      min-height: 11rem;
      padding: 1.875rem 0;
      margin: 1rem 0;
    }

    &:first-child {
      display: block;
      min-height: 7rem;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        display: flex;
        flex-wrap: wrap;
        align-items: ${props =>
          props.columnCount === '3' ? 'center' : 'flex-start'};
      }
    }

    &.optimum {
      background-color: ${themeGet('colors.chart-pink')};
    }

    &.pc-mastercard {
      background-color: ${themeGet('colors.light-border-grey')};
    }

    &.pc-money {
      background-color: ${themeGet('colors.velvet')};

      p,
      span {
        color: ${themeGet('colors.white')};
      }
    }

    &.white {
      background-color: ${themeGet('colors.white')};
    }

    ${Tab}.is-not-active.selectable-card & {
      background-color: ${themeGet('colors.light-grey')};
    }

    &.sticky.mobile-landscape {
      min-height: auto;
      padding: 0.5rem 0;
    }
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const HeaderImage = styled(Image)`
  max-height: 2.5rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 125px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    max-width: none;
  }
`;

export const CardImage = styled(Image)`
  width: auto;
  max-height: 2rem;
  margin-bottom: 0.5rem;

  @media only screen and (max-device-width: ${themeGet(
      'breakpoints.sm',
    )}) and (orientation: portrait) {
    max-height: 3rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    max-height: 2.875rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: 1rem;
    max-height: 5rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    max-height: 5.625rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    max-height: 7.125rem;
  }

  &.sticky {
    margin-bottom: 0;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin-bottom: 1rem;
      max-height: 3.5rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      margin-bottom: 1rem;
      max-height: 4.125rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      max-height: 4.75rem;
    }
  }
`;

export const Heading = styled.div`
  text-align: center;

  ${ContentWrapper}.v2 & {
    margin-bottom: 1rem;

    p {
      font-size: 1.25rem;
      line-height: 1.625rem;
    }
  }

  p {
    font-weight: ${themeGet('fontWeights.medium')};
    font-size: 0.7rem;
    line-height: 0.8rem;

    @media only screen and (min-width: 260px) {
      font-size: 0.75rem;
      line-height: 0.9rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
      font-size: 1rem;
      line-height: 1.25rem;
      padding: 0 0.25rem;
    }

    sup {
      font-size: 75%;
      ${({ lang }) =>
        lang === 'fr'
          ? css`
              font-size: 0.3rem;
              top: -0.4rem;

              @media only screen and (min-width: 340px) {
                font-size: 0.4rem;
              }

              @media only screen and (min-width: ${themeGet(
                  'breakpoints.sm',
                )}) {
                font-size: 0.5rem;
              }

              @media only screen and (min-width: ${themeGet(
                  'breakpoints.md',
                )}) {
                top: -0.5rem;
              }

              @media only screen and (min-width: ${themeGet(
                  'breakpoints.xlg',
                )}) {
                top: -0.8rem;
              }
            `
          : null}
    }
  }

  &.sticky {
    p {
      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        font-size: 0.85rem;
        line-height: 1rem;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
        font-size: 1rem;
        line-height: 1.5rem;
      }

      sup {
        ${({ lang }) =>
          lang === 'fr'
            ? css`
                font-size: 0.3rem;
                top: -0.3rem;

                @media only screen and (min-width: ${themeGet(
                    'breakpoints.xlg',
                  )}) {
                  top: -0.4rem;
                }
              `
            : null}
      }
    }

    * {
      clip: rect(0 0 0 0);
      clip-path: inset(50%);
      height: 1px;
      position: absolute;
      white-space: nowrap;
      width: 1px;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        clip: auto;
        clip-path: none;
        height: auto;
        position: relative;
        white-space: normal;
        width: auto;
      }
    }
  }
`;

export const Body = styled.div`
  width: 100%;

  ${ContentWrapper}.chart & {
    padding: 0 5px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      padding: 0 0.5rem;
    }
  }

  p,
  a {
    font-size: 0.625rem;
    line-height: 1rem;

    @media only screen and (min-width: 360px) {
      font-size: 0.675rem;
      line-height: 1rem;
    }

    @media only screen and (min-width: 414px) {
      font-size: 0.75rem;
      line-height: 1rem;
    }

    @media only screen and (min-width: 480px) {
      font-size: 0.875rem;
      line-height: 1.25rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 1rem;
      line-height: 1.5rem;
    }
  }

  a {
    display: inline-block;

    p,
    span {
      color: inherit;
      font-size: inherit;
      font-weight: inherit;
      line-height: inherit;
      letter-spacing: inherit;
    }
  }

  .sr-spacing {
    font-size: 1rem;
    font-weight: 400;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
`;

export const CarouselControls = styled.div`
  display: block;
  position: absolute;
  left: 0;
  top: calc(50% - 25px);
  width: 100%;

  ul {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    li {
      position: absolute;
    }
    li:first-child {
      left: 0.5rem;
    }
    li:last-child {
      right: 0.5rem;
    }
    li:not(:first-child) {
      margin-top: 0;
    }
  }
`;

export const CarouselBtn = styled.button`
  width: 25px;
  height: 25px;
  background-size: cover;
  &.previous-carousel {
    background-image: url(${chevronLeftBlack});
    &:disabled {
      background-image: url(${chevronLeftDisabled});
    }
  }
  &.next-carousel {
    background-image: url(${chevronRightBlack});
    &:disabled {
      background-image: url(${chevronRightDisabled});
    }
  }
`;
